import type {ReactAction} from '@netx/core/bootstrap';
import {faFilePdf} from '@fortawesome/pro-solid-svg-icons';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {cartActionCreatePDFDownload} from './cart-create-pdf-download';
import {cartActionCreatePDFShare} from './cart-create-pdf-share-link';

/**
 * Create PDF from cart contents
 * @param params
 * @returns Action
 */
export const cartActionCreatePDF = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-create-pdf',
	cb: () => {}, //dispatcher.trigger(CART_CURRENT_EVENT.CREATE_PDF),
	// enableTest: () => canCreatePdfFromCurrentCart(),
	icon: faFilePdf,
	get label() {
		return CART_CURRENT_ACTION_LABELS.CREATE_PDF;
	},
	children: [cartActionCreatePDFDownload(), cartActionCreatePDFShare()],
	...params,
});

export default cartActionCreatePDF;
